import { BucketIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  onClick: () => void;
};

export default function AccountCharDeleteTrigger({ onClick }: Props) {
  return (
    <Button
      variant="soft"
      color="gray"
      className="h-10 px-4 flex items-center relative justify-between w-full normal-case text-15"
      onClick={onClick}
    >
      <div>Удалить персонажа</div>
      <BucketIcon size={16} />
    </Button>
  );
}
